import { DefaultError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

export class ExchangeClosedByUser extends DefaultError {
  constructor() {
    super(SdkErrorCodes.EXCHANGE_CLOSED_BY_USER, SdkErrorMessages.EXCHANGE_CLOSED_BY_USER);
    this.name = "ExchangeClosedByUser";
  }
}

export class UnsubscribeError extends DefaultError {
  constructor(message: string) {
    super(SdkErrorCodes.UNSUBSCRIBE_ERROR, message);
    this.name = "UnsubscribeError";
  }
}
